import Vue from 'vue'
import Dayjs from 'dayjs'

export default Vue.extend({
  template: `
      <b-datetimepicker
        ref="datetime"
        v-model="datetime"
        placeholder="Datetime"
        :timepicker="{ enableSeconds: true }"
        icon="calendar-today"
        editable
        position="is-bottom-left"
        class="ag-input-field-input ag-text-field-input"
      />
  `,
  mounted () {
    this.datetime = new Date(this.params.value)
    this.$nextTick(() => this.$refs.datetime.toggle())
  },
  methods: {
    getValue () {
      let dateFormat = this.params.colDef.dateFormat
      if (!_.isEmpty(dateFormat)) {
        return Dayjs(this.datetime).format(dateFormat)
      } else {
        return Dayjs(this.datetime).format('YYYY-MM-DD HH:mm:ss.SSS')
      }
    },
    setValue () {
      console.log('setValue')
    },
    isPopup () {
      return true
    },
    cellStartedEdit () {
      return true
    }
  },
  data: function () {
    return {
      datetime: null
    }
  }
})
